import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { CommentContext } from '../CommentContext';
import { MobileContext } from '../../../Context';
import Timestamp from '../../../Timestamp';
import { BiLink, BiEventType } from '../../../biLogger';
var CommentTimestamp = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    var comment = useContext(CommentContext).comment;
    var isMobile = useContext(MobileContext);
    var isEdited = !!comment.edited;
    var timestamp = isEdited ? comment.edited : comment.posted;
    var showEditedPrefix = isEdited && !isMobile;
    return (React.createElement(BiLink, { href: Url.commentLink(comment.typeId, comment.itemId, comment.commentId), className: className, biData: {
            evid: BiEventType.ITEM_CLICK,
            itemid: comment.itemId,
            typeid: comment.typeId,
        } },
        showEditedPrefix && t('comment.info.edited') + " ",
        React.createElement(Timestamp, { timestamp: timestamp, showTooltip: true, isCapitalized: !showEditedPrefix })));
};
CommentTimestamp.displayName = 'CommentTimestamp';
export default CommentTimestamp;
//# sourceMappingURL=CommentTimestamp.js.map